export default "__VITE_ASSET__4952d24a__"